module.exports = __webpack_public_path__ + "img/incas-DE.63af7485.png";